import { Navigate, useLocation } from 'react-router-dom';
import { useAppAuth } from './AuthContext.jsx';
import ConsentGate from './ConsentGate.jsx';

// Guards routes that require an authenticated user. Waits for the session
// to be rehydrated, then redirects unauthenticated visitors to /login and
// sends them back on after login.
export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const { user, ready } = useAppAuth();

  if (!ready) {
    return null;
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (user.role === 'Makler' && user.has_required_consent === false) {
    return <ConsentGate />;
  }

  return children;
}
